import React from 'react'
import style from "./smallLoader.module.css"
const SmallLoader=()=>{
    return(
        <div className={style.custom_loader}></div>
    )
}
export default SmallLoader;